export function compact(array) {
  return array.filter((el) => {
    return !!el;
  });
}

export function isNullOrEmpty(val) {
  return (
    !val ||
    (Array.isArray(val) && val.length === 0) ||
    (val.constructor === Object && Object.keys(val).length === 0)
  );
}

export function log(payload) {
  process.env.NODE_ENV === 'development' && console.log(payload);
}
